import * as AddressSuggestions from "./address-suggestions";
import * as AlarmRules from "./alarm-rules";
import * as Alarms from "./alarms";
import * as Auth from "./auth";
import * as BlacklistPhones from "./blacklist-phones";
import * as BookingDetails from "./booking-details";
import * as Bookings from "./bookings";
import * as Configuration from "./configuration";
import * as Countries from "./countries";
import * as CustomerDevices from "./customer-devices";
import * as Customers from "./customers";
import * as DeviceFirmware from "./device-firmware";
import * as Devices from "./devices";
import * as Monitors from "./monitors";
import * as Nodes from "./nodes";
import * as NoiseThresholds from "./noise-thresholds";
import * as Products from "./products";
import * as Resources from "./resources";
import * as Rooms from "./rooms";
import * as TaskTypes from "./task-types";
import * as Tasks from "./tasks";
import * as ThirdParties from "./third-parties";
import * as Users from "./users";

export { CustomError } from "./errors";

export default {
  Auth,
  AlarmRules,
  BlacklistPhones,
  Devices,
  Rooms,
  Users,
  Customers,
  CustomerDevices,
  BookingDetails,
  Bookings,
  Monitors,
  Countries,
  NoiseThresholds,
  DeviceFirmware,
  Alarms,
  Resources,
  Nodes,
  AddressSuggestions,
  Configuration,
  ThirdParties,
  TaskTypes,
  Tasks,
  Products,
};
